import { Action } from '@ngrx/store';
import { Experience, ExperiencesResponse } from '@cemex-core/cmx-api';
import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';

export enum ActionTypes {
  FETCH = '[Experiences] Fetch',
  FETCH_SUCCESS = '[Experiences] Fetch Success',
  FETCH_FAILURE = '[Experiences] Fetch Failure',
  SET_EXPERIENCE = '[Experiences] Set Experience',
  SET_DEFAULT = '[Experiences] Set Deafult Experience',
  RESET = '[Experiences] Reset Experience',
  SET_ONLY_EXPERIENCE = '[Experiences] Set Only Experience',
}

export class Fetch implements Action {
  readonly type: string = ActionTypes.FETCH;

  constructor(public payload?: any) {}
}

export class FetchSuccess implements Action {
  readonly type: string = ActionTypes.FETCH_SUCCESS;
  constructor(public payload: ExperiencesResponse) {}
}

export class FetchFailure implements Action {
  readonly type: string = ActionTypes.FETCH_FAILURE;
  constructor(public payload?: any) {}
}

export class SetExperience implements Action {
  readonly type: string = ActionTypes.SET_EXPERIENCE;
  constructor(public payload: Experience) {}
}

export class SetOnlyExperience implements Action {
  readonly type: string = ActionTypes.SET_ONLY_EXPERIENCE;
  constructor(public payload: ORDER_EXPERIENCES) {}
}

export class SetDefaultExperience implements Action {
  readonly type: string = ActionTypes.SET_DEFAULT;
  constructor(public payload?: any) {}
}

export class ResetExperience implements Action {
  readonly type: string = ActionTypes.RESET;
  constructor(public payload?: any) {}
}

export type Actions = Fetch | FetchSuccess | FetchFailure | SetExperience | SetDefaultExperience | ResetExperience;
